import React, {Component} from 'react';
import { withStaticContent } from '../../../ui/components/static-content';
import './disclaimer.less';

const disclaimer = (props) => {
  return (
    <div className="blog-disclaimer"><p><em><strong>Disclosure:</strong> Our site may get a share of revenue from the sale of the products featured on this page.</em></p></div>
  );
}

export default withStaticContent(disclaimer);
